import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CapacityGranularity } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  adjustCapacity(request: Boundaries["adjustCapacity"]["request"]): void;
}

function useAdjustCapacity(
  resourceId: string,
  from: string,
  to: string,
  granularity: CapacityGranularity,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAdjustCapacityRequestPending(
        resourceId,
        from,
        to,
        granularity,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAdjustCapacityRequestSuccess(
        resourceId,
        from,
        to,
        granularity,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAdjustCapacityRequestFailure(
        resourceId,
        from,
        to,
        granularity,
      ),
    ),
    adjustCapacity: core.adjustCapacity,
  };
}

export { useAdjustCapacity };
